/* eslint-disable quotes */
export const fonts = {
  body: `'Inter', sans-serif`,
};
